import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class SearchBox extends Vue {
  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //
  placeholder: string = this.$t('이름_메일주소').toString();
  keyword: string = '';

  handleSearch() {
    this.$emit('search', this.keyword);
  }
}